var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99992 1.3335C4.31325 1.3335 1.33325 4.3135 1.33325 8.00016C1.33325 11.6868 4.31325 14.6668 7.99992 14.6668C11.6866 14.6668 14.6666 11.6868 14.6666 8.00016C14.6666 4.3135 11.6866 1.3335 7.99992 1.3335ZM10.8666 10.8668C10.6066 11.1268 10.1866 11.1268 9.92659 10.8668L7.99992 8.94016L6.07325 10.8668C5.81325 11.1268 5.39325 11.1268 5.13325 10.8668C4.87325 10.6068 4.87325 10.1868 5.13325 9.92683L7.05992 8.00016L5.13325 6.0735C4.87325 5.8135 4.87325 5.3935 5.13325 5.1335C5.39325 4.8735 5.81325 4.8735 6.07325 5.1335L7.99992 7.06016L9.92659 5.1335C10.1866 4.8735 10.6066 4.8735 10.8666 5.1335C11.1266 5.3935 11.1266 5.8135 10.8666 6.0735L8.93992 8.00016L10.8666 9.92683C11.1199 10.1802 11.1199 10.6068 10.8666 10.8668Z",
    fill: "#7E8286"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancel);
export default __webpack_public_path__ + "static/media/ic-cancel.90e4b087d11ddba097c585b821fd5c12.svg";
export { ForwardRef as ReactComponent };